<div class="remove-dialog">
  <h2 mat-dialog-title class="remove-dialog__title">{{ title() }}</h2>
  <p mat-dialog-content class="remove-dialog__message">{{ message() }}</p>
  <div mat-dialog-actions class="remove-dialog__actions">
    <button type="button" class="remove-dialog__cancel" (click)="onCancel()">{{ cancelText() }}</button>
    <button type="button" class="remove-dialog__confirm" (click)="onRemove()">{{ confirmText() }}</button>
  </div>
</div>
